import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import { sendFeedbackSuccess, sendFeedbackFailure } from './actions';
import { SendFeedbackActionTypes } from './types';
import { sendFeedback } from 'services/feedback.service';

function* handleSendFeedback(request: any) {
  try {
    const response: AxiosResponse = yield sendFeedback(request.payload);
    if (response) {
      yield put(sendFeedbackSuccess(response.data));
    } else {
      yield put(sendFeedbackFailure('Unable to send feedback'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(sendFeedbackFailure(errMsg || 'Unable to send feedback'));
  }
}

function* watchSendFeedback() {
  yield takeLatest(
    SendFeedbackActionTypes.SEND_FEEDBACK_START,
    handleSendFeedback
  );
}

function* sagas() {
  yield all([call(watchSendFeedback)]);
}

export default sagas;
